import * as React from "react";
import { useTranslation } from "react-i18next";

import News from "./News";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { NEWS_ROUTE } from "components/router/Routes";

export default function NewsView(): JSX.Element {
    const { t } = useTranslation();

    return (
        <ApplicationLayout
            viewTitle={t("Routes.news.title")}
            view={<News />}
            viewContainer={true}
            mainRoute={NEWS_ROUTE}
        />
    );
}
